/* eslint-disable import/no-cycle */

import ih from 'immutability-helper';
import { cloneDeep } from 'lodash';

import { Actions } from './actions';
import * as types from './actionTypes';
import initialState from './initialState';
// @ts-ignore
import { SELECT_PROJECT } from '../../services/project/actionTypes';

type ReducerActions = Actions | { type?: 'SELECT_PROJECT' };

export default (
  state = cloneDeep(initialState),
  action: ReducerActions = {},
) => {
  switch (action.type) {
    case types.GET_REACTIONS_REQUEST:
      return ih(state, {
        list: {
          $set: {
            isLoading: true,
            data: [],
            error: null,
          },
        },
      });
    case types.GET_REACTIONS_SUCCESS:
      return ih(state, {
        list: {
          $set: {
            isLoading: false,
            data: action.payload.reactions,
            error: null,
          },
        },
      });
    case types.GET_REACTIONS_ERROR:
      return ih(state, {
        list: {
          $set: {
            isLoading: false,
            data: [],
            error: action.payload.error,
          },
        },
      });

    case types.GET_REACTION_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_REACTION_SUCCESS:
      return ih(state, {
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { reaction } = action.payload;
              return ih(data, {
                $merge: {
                  [reaction.id]: reaction,
                },
              });
            },
          },
        },
      });
    case types.GET_REACTION_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_REACTION_INFO_REQUEST:
      return ih(state, {
        info: {
          $set: {
            isLoading: true,
            data: {},
            error: null,
          },
        },
      });
    case types.GET_REACTION_INFO_SUCCESS:
      return ih(state, {
        info: {
          $set: {
            isLoading: false,
            data: action.payload.reaction,
            error: null,
          },
        },
      });
    case types.GET_REACTION_INFO_ERROR:
      return ih(state, {
        info: {
          $set: {
            isLoading: false,
            data: {},
            error: action.payload.error,
          },
        },
      });
    case types.UPDATE_REACTION_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
        info: {
          isLoading: { $set: true },
        },
        show: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_REACTION_SUCCESS:
      return ih(state, {
        update: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { item } = action.payload;

              return ih(data, {
                $merge: {
                  [item.id]: item,
                },
              });
            },
          },
        },
        info: {
          $set: {
            isLoading: false,
            error: null,
            data: action.payload.item,
          },
        },
      });
    case types.UPDATE_REACTION_ERROR:
      return ih(state, {
        update: {
          isLoading: { $set: false },
          error: { $set: action.payload.error },
        },
        info: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_REACTION_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_REACTION_SUCCESS:
      return ih(state, {
        add: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_REACTION_ERROR:
      return ih(state, {
        add: {
          isLoading: { $set: false },
          error: { $set: action.payload.error },
        },
      });
    case types.DELETE_REACTION_SUCCESS:
      return ih(state, {
        show: {
          data: {
            $unset: [action.payload.resourceId],
          },
        },
      });
    case types.DUPLICATE_REACTION_REQUEST:
      return ih(state, {
        duplicate: {
          isLoading: { $set: true },
        },
      });
    case types.DUPLICATE_REACTION_SUCCESS:
      return ih(state, {
        duplicate: {
          isLoading: { $set: false },
        },
      });
    case types.DUPLICATE_REACTION_ERROR:
      return ih(state, {
        duplicate: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case SELECT_PROJECT:
      return ih(state, {
        $set: initialState,
      });
    default:
      return state;
  }
};
